export const LS_EDIT_ABILITTY = 'isEditEnabled';

export const IGNORE_OUTSIDE_DATA_NAME = 'ignoreClickOutside';

export const OPACITY_OPTIONS = [
  { label: '100%', code: '100%' },
  { label: '90%', code: '90%' },
  { label: '80%', code: '80%' },
  { label: '70%', code: '70%' },
  { label: '60%', code: '60%' },
  { label: '50%', code: '50%' },
  { label: '40%', code: '40%' },
  { label: '30%', code: '30%' },
  { label: '20%', code: '20%' },
  { label: '10%', code: '10%' },
  { label: '0%', code: '0%' },
];

export const FONT_FAMILY_OPTIONS = [
  { label: 'По умолчанию', code: '' },
  { label: 'Roboto', code: 'Roboto' },
  { label: 'Gilroy', code: 'Gilroy' },
  { label: 'Montserrat', code: 'Montserrat' },
  { label: 'Myriad', code: 'Myriad' },
  { label: 'Opensans', code: 'Opensans' },
  { label: 'Tahoma', code: 'Tahoma' },
  { label: 'Nunito', code: 'Nunito' },
  { label: 'Oswald', code: 'Oswald' },
  { label: 'Jost', code: 'Jost' },
  { label: 'Circe', code: 'Circe' },
  { label: 'YesevaOne', code: 'YesevaOne' },
  { label: 'DelaGothicOne', code: 'DelaGothicOne' },
  { label: 'Onest', code: 'Onest' },
  { label: 'YanoneKaffeesatz', code: 'YanoneKaffeesatz' },
];

export const FONT_WEIGHT_OPTIONS = [
  { label: 'По умолчанию', code: '' },
  { label: 'Thin', code: '100' },
  { label: 'Extra Light', code: '200' },
  { label: 'Light', code: '300' },
  { label: 'Regular', code: '400' },
  { label: 'Medium', code: '500' },
  { label: 'SemiBold ', code: '600' },
  { label: 'Bold', code: '700' },
  { label: 'Extra Bold', code: '800' },
  { label: 'Heavy', code: '900' },
];

export const STYLE_OPTIONS = [
  { label: 'Normal', code: 'normal' },
  { label: 'Italic', code: 'italic' },
];

export const FONT_SIZE_OPTIONS = [
  { label: 'По умолчанию', code: '' },
  { label: '12px', code: '12px' },
  { label: '14px', code: '14px' },
  { label: '16px', code: '16px' },
  { label: '18px', code: '18px' },
  { label: '20px', code: '20px' },
  { label: '22px', code: '22px' },
  { label: '24px', code: '24px' },
  { label: '26px', code: '26px' },
  { label: '28px', code: '28px' },
  { label: '30px', code: '30px' },
  { label: '32px', code: '32px' },
  { label: '34px', code: '34px' },
  { label: '36px', code: '36px' },
  { label: '38px', code: '38px' },
  { label: '40px', code: '40px' },
  { label: '42px', code: '42px' },
  { label: '44px', code: '44px' },
  { label: '46px', code: '46px' },
  { label: '48px', code: '48px' },
  { label: '50px', code: '50px' },
  { label: '52px', code: '52px' },
  { label: '54px', code: '54px' },
  { label: '56px', code: '56px' },
  { label: '58px', code: '58px' },
  { label: '60px', code: '60px' },
  { label: '62px', code: '62px' },
  { label: '64px', code: '64px' },
  { label: '66px', code: '66px' },
  { label: '68px', code: '68px' },
  { label: '70px', code: '70px' },
  { label: '72px', code: '72px' },
  { label: '74px', code: '74px' },
  { label: '76px', code: '76px' },
  { label: '78px', code: '78px' },
  { label: '80px', code: '80px' },
  { label: '82px', code: '82px' },
  { label: '84px', code: '84px' },
  { label: '86px', code: '86px' },
  { label: '88px', code: '88px' },
  { label: '90px', code: '90px' },
  { label: '92px', code: '92px' },
  { label: '94px', code: '94px' },
  { label: '96px', code: '96px' },
  { label: '98px', code: '98px' },
  { label: '102px', code: '102px' },
];

export const LINE_HEIGHT_OPTIONS = [
  { label: 'По умолчанию', code: '' },
  { label: '12px', code: '12px' },
  { label: '14px', code: '14px' },
  { label: '16px', code: '16px' },
  { label: '18px', code: '18px' },
  { label: '20px', code: '20px' },
  { label: '22px', code: '22px' },
  { label: '24px', code: '24px' },
  { label: '26px', code: '26px' },
  { label: '28px', code: '28px' },
  { label: '30px', code: '30px' },
  { label: '32px', code: '32px' },
  { label: '34px', code: '34px' },
  { label: '36px', code: '36px' },
  { label: '38px', code: '38px' },
  { label: '40px', code: '40px' },
  { label: '42px', code: '42px' },
  { label: '44px', code: '44px' },
  { label: '46px', code: '46px' },
  { label: '48px', code: '48px' },
  { label: '50px', code: '50px' },
  { label: '52px', code: '52px' },
  { label: '54px', code: '54px' },
  { label: '56px', code: '56px' },
  { label: '58px', code: '58px' },
  { label: '60px', code: '60px' },
  { label: '62px', code: '62px' },
  { label: '64px', code: '64px' },
  { label: '66px', code: '66px' },
  { label: '68px', code: '68px' },
  { label: '70px', code: '70px' },
  { label: '72px', code: '72px' },
  { label: '74px', code: '74px' },
  { label: '76px', code: '76px' },
  { label: '78px', code: '78px' },
  { label: '80px', code: '80px' },
  { label: '82px', code: '82px' },
  { label: '84px', code: '84px' },
  { label: '86px', code: '86px' },
  { label: '88px', code: '88px' },
  { label: '90px', code: '90px' },
];

export const TEXT_TRANSFORM_OPTIONS = [
  { label: 'Верхний регистр', code: 'uppercase' },
  { label: 'Нижний регистр', code: 'lowercase' },
  { label: 'С заглавной буквы', code: 'capitalize' },
  { label: 'По умолчанию', code: 'inherit' },
];

export const TEXT_DECORATION_OPTIONS = [
  { label: 'По умолчанию', code: 'none' },
  { label: 'Нижнее подчёркивание', code: 'underline' },
];

export const LETTER_SPACING_OPTIONS = [
  { label: 'По умолчанию', code: '' },
  { label: '0.1px', code: '0.1px' },
  { label: '0.2px', code: '0.2px' },
  { label: '0.3px', code: '0.3px' },
  { label: '0.4px', code: '0.4px' },
  { label: '0.5px', code: '0.5px' },
  { label: '0.6px', code: '0.6px' },
  { label: '0.7px', code: '0.7px' },
  { label: '0.8px', code: '0.8px' },
  { label: '0.9px', code: '0.9px' },
  { label: '1px', code: '1px' },
  { label: '1.1px', code: '1.1px' },
  { label: '1.2px', code: '1.2px' },
  { label: '1.3px', code: '1.3px' },
  { label: '1.4px', code: '1.4px' },
  { label: '1.5px', code: '1.5px' },
  { label: '1.6px', code: '1.6px' },
  { label: '1.7px', code: '1.7px' },
  { label: '1.8px', code: '1.8px' },
  { label: '1.9px', code: '1.9px' },
  { label: '2px', code: '2px' },
  { label: '2.1px', code: '2.1px' },
  { label: '2.2px', code: '2.2px' },
  { label: '2.3px', code: '2.3px' },
  { label: '2.4px', code: '2.4px' },
  { label: '2.5px', code: '2.5px' },
  { label: '2.6px', code: '2.6px' },
  { label: '2.7px', code: '2.7px' },
  { label: '2.8px', code: '2.8px' },
  { label: '2.9px', code: '2.9px' },
  { label: '3px', code: '3px' },
  { label: '3.1px', code: '3.1px' },
  { label: '3.2px', code: '3.2px' },
  { label: '3.3px', code: '3.3px' },
  { label: '3.4px', code: '3.4px' },
  { label: '3.5px', code: '3.5px' },
  { label: '3.6px', code: '3.6px' },
  { label: '3.7px', code: '3.7px' },
  { label: '3.8px', code: '3.8px' },
  { label: '3.9px', code: '3.9px' },
  { label: '4px', code: '4px' },
  { label: '4.1px', code: '4.1px' },
  { label: '4.2px', code: '4.2px' },
  { label: '4.3px', code: '4.3px' },
  { label: '4.4px', code: '4.4px' },
  { label: '4.5px', code: '4.5px' },
  { label: '4.6px', code: '4.6px' },
  { label: '4.7px', code: '4.7px' },
  { label: '4.8px', code: '4.8px' },
  { label: '4.9px', code: '4.9px' },
  { label: '5px', code: '5px' },
  { label: '5.1px', code: '5.1px' },
  { label: '5.2px', code: '5.2px' },
  { label: '5.3px', code: '5.3px' },
  { label: '5.4px', code: '5.4px' },
  { label: '5.5px', code: '5.5px' },
  { label: '5.6px', code: '5.6px' },
  { label: '5.7px', code: '5.7px' },
  { label: '5.8px', code: '5.8px' },
  { label: '5.9px', code: '5.9px' },
  { label: '6px', code: '6px' },
  { label: '6.1px', code: '6.1px' },
  { label: '6.2px', code: '6.2px' },
  { label: '6.3px', code: '6.3px' },
  { label: '6.4px', code: '6.4px' },
  { label: '6.5px', code: '6.5px' },
  { label: '6.6px', code: '6.6px' },
  { label: '6.7px', code: '6.7px' },
  { label: '6.8px', code: '6.8px' },
  { label: '6.9px', code: '6.9px' },
  { label: '7px', code: '7px' },
  { label: '7.1px', code: '7.1px' },
  { label: '7.2px', code: '7.2px' },
  { label: '7.3px', code: '7.3px' },
  { label: '7.4px', code: '7.4px' },
  { label: '7.5px', code: '7.5px' },
  { label: '7.6px', code: '7.6px' },
  { label: '7.7px', code: '7.7px' },
  { label: '7.8px', code: '7.8px' },
  { label: '7.9px', code: '7.9px' },
  { label: '8px', code: '8px' },
  { label: '8.1px', code: '8.1px' },
  { label: '8.2px', code: '8.2px' },
  { label: '8.3px', code: '8.3px' },
  { label: '8.4px', code: '8.4px' },
  { label: '8.5px', code: '8.5px' },
  { label: '8.6px', code: '8.6px' },
  { label: '8.7px', code: '8.7px' },
  { label: '8.8px', code: '8.8px' },
  { label: '8.9px', code: '8.9px' },
  { label: '9px', code: '9px' },
  { label: '9.1px', code: '9.1px' },
  { label: '9.2px', code: '9.2px' },
  { label: '9.3px', code: '9.3px' },
  { label: '9.4px', code: '9.4px' },
  { label: '9.5px', code: '9.5px' },
  { label: '9.6px', code: '9.6px' },
  { label: '9.7px', code: '9.7px' },
  { label: '9.8px', code: '9.8px' },
  { label: '9.9px', code: '9.9px' },
  { label: '10px', code: '10px' },
  { label: '-0.1px', code: '-0.1px' },
  { label: '-0.2px', code: '-0.2px' },
  { label: '-0.3px', code: '-0.3px' },
  { label: '-0.4px', code: '-0.4px' },
  { label: '-0.5px', code: '-0.5px' },
  { label: '-0.6px', code: '-0.6px' },
  { label: '-0.7px', code: '-0.7px' },
  { label: '-0.8px', code: '-0.8px' },
  { label: '-0.9px', code: '-0.9px' },
  { label: '-1px', code: '-1px' },
  { label: '-1.1px', code: '-1.1px' },
  { label: '-1.2px', code: '-1.2px' },
  { label: '-1.3px', code: '-1.3px' },
  { label: '-1.4px', code: '-1.4px' },
  { label: '-1.5px', code: '-1.5px' },
  { label: '-1.6px', code: '-1.6px' },
  { label: '-1.7px', code: '-1.7px' },
  { label: '-1.8px', code: '-1.8px' },
  { label: '-1.9px', code: '-1.9px' },
  { label: '-2px', code: '-2px' },
  { label: '-2.1px', code: '-2.1px' },
  { label: '-2.2px', code: '-2.2px' },
  { label: '-2.3px', code: '-2.3px' },
  { label: '-2.4px', code: '-2.4px' },
  { label: '-2.5px', code: '-2.5px' },
  { label: '-2.6px', code: '-2.6px' },
  { label: '-2.7px', code: '-2.7px' },
  { label: '-2.8px', code: '-2.8px' },
  { label: '-2.9px', code: '-2.9px' },
  { label: '-3px', code: '-3px' },
  { label: '-3.1px', code: '.1px' },
  { label: '-3.2px', code: '-3.2px' },
  { label: '-3.3px', code: '-3.3px' },
  { label: '-3.4px', code: '-3.4px' },
  { label: '-3.5px', code: '-3.5px' },
  { label: '-3.6px', code: '-3.6px' },
  { label: '-3.7px', code: '-3.7px' },
  { label: '-3.8px', code: '-3.8px' },
  { label: '-3.9px', code: '-3.9px' },
  { label: '-4px', code: '-4px' },
  { label: '-4.1px', code: '-4.1px' },
  { label: '-4.2px', code: '-4.2px' },
  { label: '-4.3px', code: '-4.3px' },
  { label: '-4.4px', code: '-4.4px' },
  { label: '-4.5px', code: '-4.5px' },
  { label: '-4.6px', code: '-4.6px' },
  { label: '-4.7px', code: '-4.7px' },
  { label: '-4.8px', code: '-4.8px' },
  { label: '-4.9px', code: '-4.9px' },
  { label: '-5px', code: '-5px' },
];

export enum FLEX_ALIGN {
  START = 'flex-start',
  END = 'flex-end',
  CENTER = 'center',
}

export const ALIGN_OPTIONS = [
  { label: 'По левому краю', code: 'left' },
  { label: 'По центру', code: 'center' },
  { label: 'По правому краю', code: 'right' },
];

export const ALIGN_ITEMS_OPTIONS = [
  { label: 'По верхнему краю', code: FLEX_ALIGN.START },
  { label: 'По центру', code: FLEX_ALIGN.CENTER },
  { label: 'По нижнему краю', code: FLEX_ALIGN.END },
];

export const JUSTIFY_CONTENT_OPTIONS = [
  { label: 'По левому краю', code: FLEX_ALIGN.START },
  { label: 'По центру', code: FLEX_ALIGN.CENTER },
  { label: 'По правому краю', code: FLEX_ALIGN.END },
];

export const ARCHIVE_FORMATS = [
  'application/vnd.rar',
  'application/x-rar-compressed',
  'application/octet-stream',
  'application/zip',
  'application/x-zip-compressed',
  'multipart/x-zip',
];

export const HEADER_OPTIONS = [
  { label: 'H1', code: 1 },
  { label: 'H2', code: 2 },
  { label: 'H3', code: 3 },
  { label: 'H4', code: 4 },
  { label: 'H5', code: 5 },
  { label: 'H6', code: 6 },
  { label: '-', code: NaN },
];

export const ARROW_ICON_URL = `url(${new URL('@/assets/button-icons/arrow-btn-icon.svg', import.meta.url).href})`;

export const BUTTON_ICON_OPTIONS = [{ label: '', code: ARROW_ICON_URL }];

export const BUTTON_ICON_OPTIONS_WITH_NO_ICON = [
  {
    label: 'Без иконки',
    code: '',
  },
  ...BUTTON_ICON_OPTIONS,
];

export enum BUTTON_SIZE {
  SMALL = 'small',
  MIDDLE = 'middle',
  LARGE = 'large',
}

export const BUTTON_SIZE_OPTIONS = [
  { label: 'Малая', code: BUTTON_SIZE.SMALL },
  { label: 'Средняя', code: BUTTON_SIZE.MIDDLE },
  { label: 'Большая', code: BUTTON_SIZE.LARGE },
];

export const CSS_COLORS = [
  'aliceblue',
  'antiquewhite',
  'aqua',
  'aquamarine',
  'azure',
  'beige',
  'bisque',
  'black',
  'blanchedalmond',
  'blue',
  'blueviolet',
  'brown',
  'burlywood',
  'cadetblue',
  'chartreuse',
  'chocolate',
  'coral',
  'cornflowerblue',
  'cornsilk',
  'crimson',
  'cyan\n',
  'darkblue',
  'darkcyan',
  'darkgoldenrod',
  'darkgray',
  'darkgreen',
  'darkgrey',
  'darkkhaki',
  'darkmagenta',
  'darkolivegreen',
  'darkorange',
  'darkorchid',
  'darkred',
  'darksalmon',
  'darkseagreen',
  'darkslateblue',
  'darkslategray',
  'darkslategrey',
  'darkturquoise',
  'darkviolet',
  'deeppink',
  'deepskyblue',
  'dimgray',
  'dimgrey',
  'dodgerblue',
  'firebrick',
  'floralwhite',
  'forestgreen',
  'fuchsia',
  'gainsboro',
  'ghostwhite',
  'gold',
  'goldenrod',
  'gray',
  'green',
  'greenyellow',
  'grey',
  'honeydew',
  'hotpink',
  'indianred',
  'indigo',
  'ivory',
  'khaki',
  'lavender',
  'lavenderblush',
  'lawngreen',
  'lemonchiffon',
  'lightblue',
  'lightcoral',
  'lightcyan',
  'lightgoldenrodyellow',
  'lightgray',
  'lightgreen',
  'lightgrey',
  'lightpink',
  'lightsalmon',
  'lightseagreen',
  'lightskyblue',
  'lightslategray',
  'lightslategrey',
  'lightsteelblue',
  'lightyellow',
  'lime',
  'limegreen',
  'linen',
  'magenta',
  'maroon',
  'mediumaquamarine',
  'mediumblue',
  'mediumorchid',
  'mediumpurple',
  'mediumseagreen',
  'mediumslateblue',
  'mediumspringgreen',
  'mediumturquoise',
  'mediumvioletred',
  'midnightblue',
  'mintcream',
  'mistyrose',
  'moccasin',
  'navajowhite',
  'navy',
  'oldlace',
  'olive',
  'olivedrab',
  'orange',
  'orangered',
  'orchid',
  'palegoldenrod',
  'palegreen',
  'paleturquoise',
  'palevioletred',
  'papayawhip',
  'peachpuff',
  'peru',
  'pink',
  'plum',
  'powderblue',
  'purple',
  'rebeccapurple',
  'red',
  'rosybrown',
  'royalblue',
  'saddlebrown',
  'salmon',
  'sandybrown',
  'seagreen',
  'seashell',
  'sienna',
  'silver',
  'skyblue',
  'slateblue',
  'slategray',
  'slategrey',
  'snow',
  'springgreen',
  'steelblue',
  'tan',
  'teal',
  'thistle',
  'tomato',
  'transparent',
  'turquoise',
  'violet',
  'wheat',
  'white',
  'whitesmoke',
  'yellow',
  'yellowgreen',
  'initial',
];

export const FORM_FIELD_TYPES = [
  {
    label: 'Поле ввода',
    code: 'input',
  },
  {
    label: 'Многострочное поле ввода',
    code: 'textarea',
  },
  {
    label: 'Флажок',
    code: 'checkbox',
  },
  {
    label: 'Телефон',
    code: 'tel',
  },
  {
    label: 'Электронная почта',
    code: 'email',
  },
];

export const GALLERY_SLIDER_GRID_OPTIONS = [
  { label: '1', code: 'one' },
  { label: '2', code: 'two' },
  { label: '3', code: 'three' },
  { label: '4', code: 'four' },
  { label: '5', code: 'five' },
  { label: '6', code: 'six' },
  { label: '7', code: 'seven' },
  { label: '8', code: 'eight' },
];

export enum BACKGROUND_TYPE {
  COLOR = 'color',
  IMAGE = 'image',
  VIDEO = 'video',
  GRADIENT = 'gradient',
}

export enum FILE_TYPE {
  IMAGE = 'image',
  VIDEO = 'video',
  ICON = 'icon',
}

export enum ITEM_TOGGLER_ICON_TYPES {
  IMAGE = 'image',
  STAGE = 'stage',
  TABLE = 'table',
  MENU = 'menu',
  BUTTON = 'button',
  CONTACTS = 'contacts',
  CATEGORY = 'category',
  FIELDS = 'fields',
}

export const DEFAULT_TABLE_COLUMNS_COUNT = 2;
export const MAX_TABLE_COLUMNS_COUNT = 6;

export const SHOW_PREVIEW_SLIDER_BREAKPOINT = 1280;

export const GRID_SYSTEM_COLUMNS_COUNT = 12;

export const CAROUSEL_AUTOPLAY_TIME_INTERVAL = 3000;

export const HOLDER_URL = new URL('@/assets/holder.png', import.meta.url).href;

export const VIDEO_HOLDER_URL = new URL('@/assets/video-holder.png', import.meta.url).href;

export const ICON_HOLDER_URL = new URL('@/assets/icon-holder.png', import.meta.url).href;

export const ICON_LOADER_HOLDER_URL = new URL('@/assets/icon-loader-holder.png', import.meta.url)
  .href;

export const LOGO_HOLDER_URL = new URL('@/assets/logo-holder.svg', import.meta.url).href;

export const DEFAULT_VIDEO_URL = 'https://www.youtube.com/embed/sWlbd094IR4?si=yUxJm7reE1ubNBJf';

export const DEFAULT_COVER_URL = new URL('@/assets/default_cover.jpg', import.meta.url).href;

export const SOCIAL_ICONS = {
  VK: new URL('@/assets/social/vk.png', import.meta.url).href,
  YOUTUBE: new URL('@/assets/social/youtube.png', import.meta.url).href,
  TELEGRAM: new URL('@/assets/social/telegram.png', import.meta.url).href,
  WHATSAPP: new URL('@/assets/social/whatsapp.png', import.meta.url).href,
  DZEN: new URL('@/assets/social/dzen.png', import.meta.url).href,
};

export enum FIELD_TYPES {
  FIELD = 'field',
  LIST_FIELD = 'list-field',
}

export enum GRID_OPTIONS {
  ONE = 'one',
  TWO = 'two',
  THREE = 'three',
  FOUR = 'four',
  FIVE = 'five',
}

export enum TEXT_DECORATION {
  UNDERLINE = 'underline',
}

export enum IMAGE_ASPECT_RATIOS {
  SQUARE = '1/1',
  PORTRAIT = '3/4',
  LANDSCAPE = '4/3',
}

export const GRID_OPTIONS_NUMERIC_VALUES: Record<GRID_OPTIONS, number> = {
  [GRID_OPTIONS.ONE]: 1,
  [GRID_OPTIONS.TWO]: 2,
  [GRID_OPTIONS.THREE]: 3,
  [GRID_OPTIONS.FOUR]: 4,
  [GRID_OPTIONS.FIVE]: 5,
};

export enum TEXT_SETTINGS {
  FONT_STYLE = 'fontStyle',
  TEXT_DECORATION = 'textDecoration',
  TEXT_ALIGN = 'textAlign',
  FONT_COLOR = 'color',
  FONT_FAMILY = 'fontFamily',
  FONT_WEIGHT = 'fontWeight',
  FONT_SIZE = 'fontSize',
  LINE_HEIGHT = 'lineHeight',
  LETTER_SPACING = 'letterSpacing',
  TEXT_TRANSFORM = 'textTransform',
}

export const TEXT_INTERVALS_SETTINGS = [TEXT_SETTINGS.LINE_HEIGHT, TEXT_SETTINGS.LETTER_SPACING];
export const BASE_TEXT_SETTINGS = [
  TEXT_SETTINGS.FONT_COLOR,
  TEXT_SETTINGS.FONT_FAMILY,
  TEXT_SETTINGS.FONT_WEIGHT,
  TEXT_SETTINGS.FONT_SIZE,
];
export const FULL_TEXT_SETTINGS = [
  ...BASE_TEXT_SETTINGS,
  ...TEXT_INTERVALS_SETTINGS,
  TEXT_SETTINGS.FONT_STYLE,
  TEXT_SETTINGS.TEXT_ALIGN,
];

export enum CURRENCY {
  ROUBLES = 'roubles',
}

export const CURRENCY_OPTIONS = [{ label: 'Рубли', code: CURRENCY.ROUBLES }];

export enum PERIOD {
  MONTH = 'month',
  YEAR = 'year',
}

export const PERIOD_OPTIONS = [
  { label: 'Месяц', code: PERIOD.MONTH },
  { label: 'Год', code: PERIOD.YEAR },
];

export const LIGHT_FONT_WEIGHT = 300;
export const MEDIUM_FONT_WEIGHT = 500;

export const CUSTOM_PAGE_MODAL_WIDTH = 940;

export enum FOOTER_COLUMNS_COUNT {
  ONE = 1,
  TWO = 2,
  THREE = 3,
}

export enum CONTACTS_TYPE {
  TELEPHONE = 'tel',
  EMAIL = 'email',
  ADDRESS = 'address',
}

export const CONTACT_FIELDS = [
  'contactsColor',
  'contactsFontFamily',
  'contactsFontWeight',
  'contactsFontSize',
  'contactsLineHeight',
  'contactsLetterSpacing',
  'contactsFontStyle',
  'contactsTextAlign',
  'contactsHoverColor',
  'contactsHoverFontWeight',
  'contactsTextTransform',
  'contactsTextDecoration',
] as const;

export enum QUILL_LINK_EVENTS {
  LINK = 'link',
  OPEN_CUSTOM_PAGE_MODAL = 'openCustomPageModal',
}

export const QUILL_LINK_EVENT_OPTIONS = [
  { label: 'Переход по ссылке', code: QUILL_LINK_EVENTS.LINK },
  { label: 'Открыть модальное окно', code: QUILL_LINK_EVENTS.OPEN_CUSTOM_PAGE_MODAL },
];

export enum TOOLBAR_ICONS {
  VIEW = 'view',
  HIDE = 'hide',
  EDIT = 'edit',
  GRID_VIEW = 'grid-view',
  GRID_HIDE = 'grid-hide',
  COMPONENT = 'component',
  MENU = 'menu',
  ARROW_TOP = 'arrow-top',
  ARROW_BOTTOM = 'arrow-bottom',
}
